export const environment = {
  firebase: {
    apiKey: "AIzaSyD7TbaxlfzvBwbdgwrfAvB4dUhTO6-la28",
    authDomain: "car-finder-genie---development.firebaseapp.com",
    databaseURL: "https://car-finder-genie---development-default-rtdb.firebaseio.com",
    projectId: "car-finder-genie---development",
    storageBucket: "car-finder-genie---development.firebasestorage.app",
    messagingSenderId: "262122308239",
    appId: "1:262122308239:web:4f2b74ab89cbf70a49e6fa",
    measurementId: "G-TQ9TS1T5PL"
  },
  mapbox_token: 'pk.eyJ1IjoibWVuZGV6YW5kZXJzb25zcyIsImEiOiJjbDJ4ZmdieW4wcGV6M2Ruc2dmNW53bW9mIn0.4fKDOg5NA0XEv4QwNpm-_A',
  vapidkey: 'BBkPCSvCcN5uIPQHfCJvW-M8tocqH7kg4igViFwIW6TRR2x8WI8KdezdtJ-k_R888_y8fQX9e5B-zR0-JqZ1Gf0',
  cloud_functions_urls: {
    createNewChat: 'https://createnewchat-es44pijfea-uc.a.run.app',
    createUniqueChatID: 'https://createuniquechatid-es44pijfea-uc.a.run.app',
    sendNewMessage: 'https://sendnewmessage-es44pijfea-uc.a.run.app',
    updateUserPhoneNumber: 'https://updateuserphonenumber-es44pijfea-uc.a.run.app',
    sendPushNotifications: 'https://sendpushnotifications-es44pijfea-uc.a.run.app',
    createStripeCustomer: 'https://createstripecustomer-es44pijfea-uc.a.run.app',
    createStripeCard: 'https://createstripecard-es44pijfea-uc.a.run.app',
    createStripeProduct: 'https://createstripeproduct-es44pijfea-uc.a.run.app',
    getStripeProducts: 'https://getstripeproducts-es44pijfea-uc.a.run.app',
    getStripeProductPrice: 'https://getstripeproductprice-es44pijfea-uc.a.run.app',
    getStripePaymentLink: 'https://getstripepaymentlink-es44pijfea-uc.a.run.app',
    getCustomerPaymentMethod: 'https://us-central1-car-finder-genie---development.cloudfunctions.net/getCustomerPaymentMethod',
    getCustomerPaymentMethodList: 'https://us-central1-car-finder-genie---development.cloudfunctions.net/getCustomerPaymentMethodList',
    addNewPaymentMethod: 'https://us-central1-car-finder-genie---development.cloudfunctions.net/addNewPaymentMethod',
    getCustomerSubscription: 'https://us-central1-car-finder-genie---development.cloudfunctions.net/getCustomerSubscription',
    cancelCustomerSubscription: 'https://us-central1-car-finder-genie---development.cloudfunctions.net/cancelCustomerSubscription',
    deletePaymentMethod: 'https://us-central1-car-finder-genie---development.cloudfunctions.net/deletePaymentMethod',
    deleteCustomer: 'https://us-central1-car-finder-genie---development.cloudfunctions.net/deleteCustomer',
    createCustomerSubscription: 'https://us-central1-car-finder-genie---development.cloudfunctions.net/createCustomerSubscription',
    getCustomerSubscriptionById: 'https://us-central1-car-finder-genie---development.cloudfunctions.net/getCustomerSubscriptionById',
    sendWelcomeEmail: 'https://sendwelcometemail-es44pijfea-uc.a.run.app',
    sendMessageNotificationEmail: 'https://sendmessagenotificationemail-es44pijfea-uc.a.run.app',
    createAndRegisterLead: 'https://us-central1-car-finder-genie---development.cloudfunctions.net/createAndRegisterLead',
    
  },
  redirection_website: 'https://leadsfindergenie.com/',
  name: 'DESARROLLO',
  sentry_dns: 'https://e2b7366da31b50310fe370f6c96ab452@o4509053127163904.ingest.us.sentry.io/4509221956681728',
  is_pwa: true,
  sentry_env_name: 'development',
  production: false
};
